export default "__VITE_ASSET__hxyRYHZ9__"